import { Reducer } from "redux";
import { VASTransactionState, TransactionTypes } from "./types";
import { AuthActionTypes } from "../auth";

export const initialState: VASTransactionState = {
  currencies: [],
  currenciesLoading: false,
  currencyError: null,
  error: null,
  loading: false,
  transactions: null,
  isExporting: false,
  exportStream: undefined,
  isExportSuccess: false,
  isExportError: false,
  exportError: null,
  downloadReceiptStream: undefined,
  downloadRecieptError: false,
  downloadRecieptSuccess: false,
  isRequestingDownload: false,
  downloadError: null,
  vasDashboard: null,
  vasDashboardLoading: false,
  vasDashboardError: null,
  collectionDashboard: null,
  collectionDashboardLoading: false,
  collectionDashboardError: null,
};

const reducer: Reducer<VASTransactionState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TransactionTypes.GET_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        transactions: null,
        error: undefined,
      };
    case TransactionTypes.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: action.payload,
        loading: false,
      };
    case TransactionTypes.GET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        transactions: null,
        loading: false,
        error: action.payload,
      };
    case TransactionTypes.GET_CURRENCIES:
      return {
        ...state,
        currenciesLoading: true,
      };
    case TransactionTypes.GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: action.payload,
        currenciesLoading: false,
      };
    case TransactionTypes.GET_CURRENCIES_FAILURE:
      return {
        ...state,
        currenciesLoading: false,
        currencyError: action.payload,
      };
    case TransactionTypes.EXPORT_TRANSACTIONS_REQUEST:
      return {
        ...state,
        isExporting: true,
      };
    case TransactionTypes.EXPORT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isExporting: false,
        exportStream: action.payload,
        isExportError: false,
        isExportSuccess: true,
        exportError: undefined,
      };
    case TransactionTypes.EXPORT_TRANSACTIONS_FAILURE:
      return {
        ...state,
        isExporting: false,
        exportStream: undefined,
        isExportError: true,
        isExportSuccess: false,
        exportError: action.payload,
      };
    case TransactionTypes.DOWNLOAD_RECEIPT_REQUEST:
      return {
        ...state,
        isRequestingDownload: true,
      };

    case TransactionTypes.DOWNLOAD_RECEIPT_SUCCESS:
      return {
        ...state,
        isRequestingDownload: false,
        downloadReceiptStream: action.payload,
        downloadRecieptError: false,
        downloadRecieptSuccess: true,
        downloadError: undefined,
      };

    case TransactionTypes.DOWNLOAD_RECEIPT_FAILURE:
      return {
        ...state,
        isRequestingDownload: false,
        downloadReceiptStream: undefined,
        downloadRecieptError: true,
        downloadRecieptSuccess: false,
        downloadError: action.payload,
      };
    case TransactionTypes.CLEAR_VAS:
      return {
        ...state,
        vasDashboard: null,
        vasDashboardLoading: false,
        vasDashboardError: null,
        collectionDashboard: null,
        collectionDashboardLoading: false,
        collectionDashboardError: null,
        transactions: null,
      };
    case AuthActionTypes.DESTROY_STATES:
      return initialState;
    case TransactionTypes.GET_VAS_DASHBOARD_REQUEST:
      return {
        ...state,
        vasDashboardLoading: true,
        vasDashboardError: null,
      };
    case TransactionTypes.GET_VAS_DASHBOARD_SUCCESS:
      return {
        ...state,
        vasDashboard: action.payload,
        vasDashboardLoading: false,
      };
    case TransactionTypes.GET_VAS_DASHBOARD_FAILURE:
      return {
        ...state,
        vasDashboardError: action.payload,
        vasDashboardLoading: false,
      };
    case TransactionTypes.GET_COLLECTION_DASHBOARD_REQUEST:
      return {
        ...state,
        collectionDashboardLoading: true,
        collectionDashboardError: null,
      };
    case TransactionTypes.GET_COLLECTION_DASHBOARD_SUCCESS:
      return {
        ...state,
        collectionDashboard: action.payload,
        collectionDashboardLoading: false,
      };
    case TransactionTypes.GET_COLLECTION_DASHBOARD_FAILURE:
      return {
        ...state,
        collectionDashboardError: action.payload,
        collectionDashboardLoading: false,
      };
    default:
      return state;
  }
};

export { reducer as vasTransactionTableReducer };
